module.exports = ".infopanel{\n    position: absolute;\n    bottom: 100px;\n    background: white;\n    padding: 20px;\n    border-radius: 20px;\n    font-size: 15px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/infopanel/infopanel.component.css
// module id = ./src/app/infopanel/infopanel.component.css
// module chunks = main